import { get, put } from '../http';

export const getInvoices = async () => {
    try {
        const response = await get('/api/bcmypages/invoices');

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        throw error;
    }
};

export const updatePassword = async (password, confirmPassword) => {
    try {
        const response = await put('/api/bcmypages/users/password', {
            password: password,
            confirmPassword: confirmPassword,
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};
